import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const Loading = () => {
  const theme = useTheme();

  return (
    <Box display="flex" flexGrow={1} justifyContent="center" margin={theme.spacing(1)}>
      <Typography variant="caption">Loading...</Typography>
    </Box>
  );
};

export default Loading;
